// Pictures for 絵合わせ nights: 16x16 stencils, '#' is part of the picture.
// The date picks one; full-moon nights favour the moon rabbit.
export const MOTIFS = {
  rabbit: [
    '................', '.....##...##....', '.....##...##....', '.....##...##....', '.....##...##....', '....#########...',
    '...###########..', '...###.#####.##.', '...###########..', '....#########...', '...###########..', '..#############.',
    '..#############.', '..#############.', '...###########..', '....##.....##...'],
  crane: [
    '................', '.........##.....', '........####....', '.##....###......', '..###.###.......', '...######.......',
    '....#####.......', '...#######......', '..#########.....', '.####...####....', '###......####...', '##........###...',
    '...........##...', '............#...', '................', '................'],
  wave: [
    '................', '....######......', '..##......##....', '.#..######..#...', '#..#......#..#..', '#.#..####..#.#..',
    '#.#.#....#.#.#..', '################', '...######.......', '.##......##.....', '#..######..#....', '#.#......#.#....',
    '##..####..##....', '#..#....#..#....', '################', '................'],
  crescent: [
    '................', '......####......', '....######......', '...######.......', '..######........', '..#####.........',
    '.######.........', '.######.........', '.######.........', '.######.........', '..######........', '..#######.......',
    '...########.....', '....#########...', '......#####.....', '................'],
  dango: [
    '................', '................', '......####......', '.....######.....', '.....######.....', '......####......',
    '...####..####...', '..######.######.', '..######.######.', '...####..####...', '................', '################',
    '.##############.', '..############..', '................', '................'],
  kikyo: [
    '................', '.......##.......', '......####......', '......####......', '.##...####...##.', '.####..##..####.',
    '..#####..#####..', '...####..####...', '....###..###....', '.......##.......', '....#.####.#....', '...###.##.###...',
    '...####..####...', '..####....####..', '..###......###..', '................'],
  fish: [
    '................', '................', '................', '.....######.....', '...##########.#.', '..#############.',
    '.##.##########..', '.##############.', '..#############.', '...##########.#.', '.....######.....', '................',
    '................', '................', '................', '................'],
  boat: [
    '................', '.......#........', '.......##.......', '.......###......', '.......####.....', '.......#####....',
    '.......######...', '.......#######..', '.......#........', '.......#........', '################', '.##############.',
    '..############..', '...##########...', '................', '................'],
};
